// LogoImage.js
import React from 'react';
import { Image as PdfImage } from '@react-pdf/renderer';
import logoPng from '../../images/PINSTACK.jpeg';   // adjust path as needed

/**
 * Props
 * -----
 * className  – optional extra classes for web rendering
 * width      – max width in pixels (default = 100)
 * pdfMode    – true  ➜ render <PdfImage>   (for React-PDF)
 *              false ➜ render <img>        (for browser)
 */
const LogoImage = ({ className = '', width = 100, pdfMode = false }) => {
  // ---------- React-PDF ----------
  if (pdfMode) {
    return (
      <PdfImage
        src={logoPng}
        style={{
          width,
          objectFit: 'contain',
        }}
      />
    );
  }

  // ---------- Browser ----------
  return (
    <img
      src={logoPng}
      alt="PinStack Logo"
      className={`logo-img ${className}`}
      style={{ maxWidth: width, objectFit: 'contain' }}
    />
  );
};

export default LogoImage;
